import {cloudflareImageURL} from "@client/utils";
import {classNames} from "@reactivated";
import * as React from "react";

const sizes = {
    // Journal rows: replaces the hand-drawn 32px circle in MealCard.
    journal: "size-8",
    // Search, recents and ingredient cards, which have taller rows.
    card: "size-10",
    // Beside the name on entry and ingredient screens.
    headline: "size-[52px]",
} as const;

export const EntryIcon = (props: {
    icon: {cloudflare_image_id: string | null} | null | undefined;
    size: keyof typeof sizes;
}) => {
    if (props.icon == null || props.icon.cloudflare_image_id == null) {
        return null;
    }
    return (
        <img
            alt=""
            aria-hidden="true"
            loading="lazy"
            decoding="async"
            src={cloudflareImageURL(props.icon.cloudflare_image_id, "thumbnail")}
            className={classNames(
                sizes[props.size],
                "shrink-0 rounded-full border-2 border-[oklch(0.51_0.21_278)] bg-stone-100 object-cover",
            )}
        />
    );
};
